import type { Messages } from "@prop/i18n";
import type en from "../en/legal";

export default {
  updated: "Versión 1.0 · vigente desde el 31 de octubre de 2026",
  contents: "Contenido",
  documents: "Documentos legales",
  questions: "Preguntas sobre estos documentos: hello@fundedlime.com",
  nav: {
    terms: "Términos y condiciones",
    refunds: "Pagos y reembolsos",
    payouts: "Política de payouts",
    prohibited: "Prácticas prohibidas",
    aml: "AML y KYC",
    privacy: "Política de privacidad",
    cookies: "Política de cookies",
    risk: "Divulgación de riesgos",
    execution: "Política de ejecución",
  },
  consent: {
    title: "Cookies",
    body: "Solo usamos las cookies que el sitio necesita para funcionar y mantenerse seguro. Las opcionales (analítica, marketing, el gráfico de TradingView) solo funcionan si las permites.",
    policy: "Política de cookies",
    acceptAll: "Aceptar todas",
    necessaryOnly: "Solo necesarias",
    settings: "Configuración",
    save: "Guardar selección",
    close: "Cerrar",
    open: "Configuración de cookies",
    always: "Siempre activas",
    notUsed: "No se usan hoy",
    necessary: { name: "Estrictamente necesarias", note: "Inicio de sesión, seguridad, prevención del fraude y recordar esta elección. No pueden desactivarse." },
    analytics: { name: "Analítica", note: "Estadísticas de visitantes para mejorar el sitio. Hoy no usamos ninguna; si las agregamos, solo funcionarán con esta opción activada." },
    marketing: { name: "Marketing", note: "Publicidad y retargeting. Hoy no usamos ninguno; si los agregamos, solo funcionarán con esta opción activada." },
    external: { name: "Contenido externo", note: "El gráfico opcional de TradingView en la terminal. TradingView recibe tu dirección IP y puede instalar sus propias cookies." },
  },
  tvGate: {
    title: "Gráfico de TradingView",
    body: "Esta vista se carga desde TradingView, que recibe tu dirección IP y puede instalar sus propias cookies.",
    load: "Cargar TradingView",
    policy: "Política de cookies",
  },
} satisfies Messages<typeof en>;
